<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="true"
    :title="$t('placeOrder.BatchExport')"
    :visible.sync="dialogVisibleExport"
    top="10vh"
    width="500px"
    @close="clearForm"
  >
    <el-form
      ref="exportRuleForm"
      :model="exportRuleForm"
      class="demo-exportRuleForm"
      label-position="top"
    >
      <el-form-item
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur', 'change']
        }"
        prop="NumberType"
      >
        <el-select
          v-model="exportRuleForm.NumberType"
          style="width: 80%"
          @change="handleNumberTypeChange"
        >
          <!--运单号-->
          <el-option key="1" :label="$t('orderCenterCont.anjunWaybillNumber')" :value="1" />
          <!--服务商单号-->
          <el-option key="2" :label="$t('GlobalSetObj.serviceLogistics')" :value="2" />
          <!--客户订单号-->
          <el-option key="3" :label="$t('newOrder.PlatformOrderNumber')" :value="3" />
          <!--中转仓袋号-->
          <el-option key="4" :label="$t('orderCenterCont.TransitBinBagNumber')" :value="4" />
          <!--子包号-->
          <el-option key="5" :label="$t('orderCenterCont.SubpackageNumber')" :value="5" />
          <!--派送路线-->
          <!--          <el-option key="6" :label="$t('newOrder.InvoiceNumber')" value="6" />-->
        </el-select>
      </el-form-item>
      <el-form-item
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur']
        }"
        prop="inputValeu"
        style="width: 100%"
      >
        <el-input
          v-model="exportRuleForm.inputValeu"
          :placeholder="$t('orderCenterCont.Multiple')"
          clearable
          rows="6"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <div>
      <el-radio v-model="radio" label="1">{{ $t('GlobalSetObj.ExportingList') }}</el-radio>
      <el-radio v-model="radio" label="2">{{ $t('GlobalSetObj.ExportReceipt') }}</el-radio>
      <el-radio v-model="radio" label="3">{{ $t('GlobalSetObj.ExportSubPackage') }}</el-radio>
      <el-radio v-model="radio" :disabled="secondLatestTrackRadioDisabled" label="4">
        {{ $t('GlobalSetObj.ExportSecondLatestTrack') }}
      </el-radio>
      <el-radio v-model="radio" label="5">
        {{ $t('GlobalSetObj.crossBorderInvoiceInfo') }}
      </el-radio>
    </div>
    <div style="text-align: right; margin: 15px 0">
      <el-button size="small" @click="dialogVisibleExport = false">{{
          $t('GlobalSetObj.Cancelar')
        }}</el-button>
      <el-button
        size="small" type="primary" @click="comfire"
      >{{ $t('collectionCenter.CheckItOutNow') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  archiveListInfoExport,
  archiveTfkInfoExport,
  archiveSecondLatestTrackExport,
  archiveChildPackageInfoExport,
  archiveSignInfoExport
} from '@/api/logisticsOrders';
import { goRWExportList } from '@/utils/goExportList';

export default {
  name: 'OrderNumberExport',
  data() {
    return {
      dialogVisibleExport: false,
      exportRuleForm: {
        NumberType: 1,
        inputValeu: ''
      },
      radio: '1',
      // 用于控制“次新轨迹导出” radio 的启用/禁用
      secondLatestTrackRadioDisabled: false
    };
  },
  methods: {
    handleOpen() {
      this.dialogVisibleExport = true;
      this.radio = '1';
    },
    clearForm() {
      console.log('clearForm');
      this.exportRuleForm.NumberType = 1;
      this.secondLatestTrackRadioDisabled = false;
      this.exportRuleForm.inputValeu = '';
    },
    // 处理单号类型切换
    handleNumberTypeChange(value) {
      if (value !== 1) {
        this.secondLatestTrackRadioDisabled = true;
        if (this.radio === '4') {
          this.radio = '1';
        }
      } else {
        this.secondLatestTrackRadioDisabled = false;
      }
    },
    comfire() {
      this.$refs['exportRuleForm'].validate((valid) => {
        if (valid) {
          const numberList = this.exportRuleForm.inputValeu
            ? this.exportRuleForm.inputValeu.split('\n')
            : [];
          const numList = numberList.filter((item) => item !== '');
          if (numList.length > 100000) {
            this.$message.error(this.$t('GlobalSetObj.notMore10w'));
            return;
          }
          const param = {
            numberType: this.exportRuleForm.NumberType,
            numberList: numList
          };
          if (this.radio === '1') {
            // 导出列表信息
            archiveListInfoExport(param).then((res) => {
              if (res.code === 200) {
                this.dialogVisibleExport = false;
                goRWExportList(this);
              }
            });
          } else if (this.radio === '2') {
            // 导出签收信息
            archiveSignInfoExport(param).then((res) => {
              if (res.code === 200) {
                this.dialogVisibleExport = false;
                goRWExportList(this);
              }
            });
          } else if (this.radio === '3') {
            // 导出子包信息
            archiveChildPackageInfoExport(param).then((res) => {
              if (res.code === 200) {
                this.dialogVisibleExport = false;
                goRWExportList(this);
              }
            });
          } else if (this.radio === '4') {
            // 次新轨迹导出
            archiveSecondLatestTrackExport(param).then((res) => {
              if (res.code === 200) {
                this.dialogVisibleExport = false;
                goRWExportList(this);
              }
            });
          } else if (this.radio === '5') {
            // 跨境发票信息
            archiveTfkInfoExport(param).then((res) => {
              if (res.code === 200) {
                this.dialogVisibleExport = false;
                goRWExportList(this);
              }
            });
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped></style>
